import IconAdd from "@/assets/images/icon-add.svg?react";
import IconChevronArrow from "@/assets/images/icon-arrow-down.svg?react";
import styled from "@emotion/styled";

export const IconAddStyle = styled(IconAdd)`
  & path {
    fill: #3548c9;
  }
`;

export const IconChevronArrowStyle = styled(IconChevronArrow)`
  & path {
    fill: #3548c9;
  }
`;

export const IconChevronArrowStyleWhite = styled(IconChevronArrow)`
  & path {
    fill: #ffffff;
  }
`;

export const Root = styled.form`
  padding: 0 20px;
`;

export const Title = styled.p`
  font-size: 24px;
  font-weight: 500;
  color: #000000;
  margin: 30px 0;
`;

export const TextDetail = styled.p`
  font-size: 12px;
  font-weight: 400;
  color: #333;
  margin: 0;
`;

export const SubTextDetail = styled.p`
  font-size: 14px;
  font-weight: 00;
  color: #253858;
  margin: 0;
`;

export const StatusText = styled.div`
  border-radius: 100px;
  background-color: #e7e9ed;
  padding: 5px 12px;
  font-size: 14px;
  font-weight: 700;
  color: #395278;
  width: fit-content;
`;

export const Body = styled.div`
  width: 100%;
  display: flex;
  gap: 20px;
`;

export const LayoutLeft = styled.div`
  width: 30%;
  display: grid;
  gap: 20px;
  height: fit-content;
  & .card-information > .theme-card-body {
    display: grid;
    gap: 10px;
  }
  & .card-detail > .theme-card-body {
    display: grid;
    gap: 20px;
  }
  & .card-repeat {
    width: 100%;
    border: unset;
    & .theme-accordion-heading {
      padding: 0;
      border-bottom: unset;
      & .theme-accordion-title {
        font-size: 14px;
        font-weight: 500;
      }
    }
    & .theme-accordion-body {
      padding: 0;
    }
  }
`;

export const TitleRepeat = styled.p`
  font-weight: 700;
  font-size: 14px;
  line-height: 140%;
  letter-spacing: -0.2px;
  vertical-align: middle;
  margin-bottom: 12px;
  margin-top: 24px;
`;

export const RadioRepeat = styled.div<{ $widthInput?: number; $mt?: number }>`
  margin-top: ${({ $mt }) => $mt}px;
  & > div {
    display: flex;
    gap: 12px;
    align-items: center;
    & .theme-form-input-container {
      width: ${({ $widthInput }) => $widthInput}px;
    }
    & .rc-input-number {
      width: ${({ $widthInput }) => $widthInput}px;
    }
    & label {
      display: flex;
      align-items: center;
      font-weight: 500;
      font-size: 14px;
      line-height: 100%;
      letter-spacing: -0.2px;
      gap: 12px;
    }
    & input[type="radio"] {
      width: 16px;
      height: 16px;
      margin: 0;
    }
  }
`;

export const CardDetail = styled.div`
  display: grid;
  gap: 10px;
`;

export const LayoutRight = styled.div`
  width: 70%;
  display: grid;
  gap: 20px;
  height: fit-content;
  & .card-channel {
    background-color: #fff;
    & .theme-accordion-body > div {
      display: grid;
      gap: 24px;
    }
  }

  & .card-additional-parameter {
    background-color: #f4f5f7;
    border: none;

    & .theme-accordion-body {
      border-radius: 5px;
    }
    & .theme-accordion-body > div {
      display: grid;
      gap: 24px;
      border: none;
    }

    & .theme-accordion-heading {
      background-color: #f4f5f7;
      border: none;
      padding-left: 0px;
    }
  }

  & .dialog-additional-parameter {
    & .theme-dialog-body {
      height: 30rem;
      overflow-y: auto;
    }
  }
  & .button-add-channel {
    width: fit-content;
  }

  & .button-add-parameter {
    width: fit-content;
    margin-left: auto;

    &:disabled {
      cursor: not-allowed;
      opacity: 0.6;
    }
  }
`;

export const ReferOutButtonContainer = styled.div`
  display: flex;
  gap: 24px;
  justify-content: center;
  padding: 24px 16px;
  & button {
    width: 92px;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 24px;
  justify-content: flex-end;
  padding: 24px 16px;
  & button {
    width: 92px;
  }
`;
